import { Menu } from '../models/menu.model';
import { apiService } from './api.service';

export const getMenuByRoleService = (roleId: string): Promise<Menu[]> => {
  return apiService.getInstance().get(`/menu/role/${roleId}`);
};

export const getMenuByUserService = (): Promise<Menu[]> => {
  return apiService.getInstance().get(`/menu/user`);
};
